import React, { PureComponent } from "react";
import classnames from "classnames";
import "react-day-picker/lib/style.css";
import DayPicker from "react-day-picker";
import { NavLink } from "react-router-dom";
import MomentLocaleUtils from "react-day-picker/moment";
import "moment/locale/fr";
import _ from "i18n";

import { mapAndSortCalendarPlanningByMonth } from "Utils";
import { MONTHS } from "Config";

import tasksApi from "../../services/TasksServices";

import styles from "./CollaboratorSpace.local.scss";

class CollaboratorCalendar extends PureComponent {
  //******************   Content Functions  **************//

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: false,
      selectedDay: undefined,
      isAgenda: true,
      isBirthday: false,
      locale: "ar",
      year: this.props.year,
      period: this.props.period,
      data: [],
      month: new Date().getMonth()
    };

    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { year, date } = this.props;
    if (prevProps.year !== year || prevProps.date !== date) {
      setTimeout(() => this.fetchCalendarSettings(), 200);
      this.setState({ year: year, month: new Date(date).getMonth() });
    }
  }

  reformatDate(jours) {
    let modifiersDates = {};
    let planningDates = {};

    for (let type in jours.modifiers) {
      modifiersDates[type] = jours.modifiers[type].map(item => {
        return new Date(item);
      });
    }

    for (let type in jours.planning) {
      planningDates[type] = {};
      for (let month in jours.planning[type]) {
        planningDates[type][month] = jours.planning[type][month].map(item => {
          return { ...item, date: new Date(item.date) };
        });
      }
    }
    return {
      ...jours,
      planning: planningDates,
      modifiers: modifiersDates
    };
  }
  fetchCalendarSettings = () => {
    // this.setState({ loading: true });
    tasksApi
      .fetchCalendarSettings(
        this.props.organization.id,
        this.props.user.uid,
        this.props.user.adminsId,
        this.props.year
      )
      .then(response => {
        this.setState({
          data: this.reformatDate(response),
          loading: false
        });
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.OnAgendaClick();
    this.fetchCalendarSettings();
  }

  onNextClick() {
    if (this.state.month < 11) {
      this.setState({ month: this.state.month + 1 });
    }
  }
  onPrevClick() {
    if (this.state.month > 0) {
      this.setState({ month: this.state.month - 1 });
    }
  }

  OnBirthdayClick() {
    this.setState({
      isAgenda: false,
      isBirthday: true
    });
  }
  OnAgendaClick() {
    this.setState({
      isAgenda: true,
      isBirthday: false
    });
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  // *****************   RENDERING  ***********************

  renderMonthsTags = () => {
    let plan = this.state.data.planning;
    let monthsRendering = [];
    let options = [];
    for (let type in plan) {
      options.push(type);
    }

    if (this.state.data.planning) {
      let tags = mapAndSortCalendarPlanningByMonth(
        plan,
        MONTHS[this.state.month],
        options
      );
      if (this.renderTags(MONTHS[this.state.month], tags).length === 0) {
        monthsRendering.push(
          <div className={styles.noData}>
            <h6 style={{ fontSize: 13 }}>{_("noEvent")}</h6>
          </div>
        );
      } else {
        monthsRendering.push(
          <div className={styles.tag_month} key={MONTHS[this.state.month]}>
            {this.renderTags(MONTHS[this.state.month], tags)}
          </div>
        );
      }
    }
    return monthsRendering;
  };

  renderTags = (month, tags) => {
    let tagsRendering = [];
    tags.forEach((item, i) => {
      tagsRendering.push(
        <div
          className={classnames(
            styles.tag,
            item[0].option === "holidays"
              ? styles.holidays
              : item[0].option === "annualHolidays"
                ? styles.annualHolidays
                : styles.workingDays
          )}
          key={"month_tag_" + i}
        >
          <span className={classnames(styles.tag_color)} />
          <span className={styles.tag_label}>
            {_(
              item[0].label !== "annualHolidays"
                ? item[0].label
                : "Congé fixe - RTT"
            )}{" "}
            :{" "}
            <b>
              {item.map((date, i) => {
                if (i === 0) {
                  return date.date.getDate();
                } else {
                  return " - " + date.date.getDate();
                }
              })}
            </b>
          </span>
          <div
            className={styles.actions_container}
            onClick={event => {
              event.stopPropagation();
            }}
          />
        </div>
      );
    });
    return tagsRendering;
  };

  renderCalendarSection = () => {
    const { isAgenda, isBirthday, locale } = this.state;
    const {
      data: { modifiers }
    } = this.state;
    let defaultModifiers = {
      weekend: { daysOfWeek: [0, 6] }
    };
    return (
      <div
        className={classnames(
          styles.calendar_section,
          this.props.from === "MANAGER_VIEW"
            ? styles.calendar_small_section
            : styles.calendar_large_section
        )}
      >
        <div className={styles.entete} style={{ margin: "10px 0px 20px" }}>
          <h3 className={styles.title}>{_("calendrier")}</h3>
          <div className={styles.explore_button}>
            <NavLink
              to={`/collaborator-calendar`}
              activeClassName="active"
              className="menu__link"
            >
              <span className={styles.text_explore}>{_("explorer")}</span>
            </NavLink>
          </div>
        </div>
        <div className={styles.entete}>
          <div
            className={classnames(styles.leftButton, styles.explore_button)}
            onClick={this.onPrevClick}
          >
            <img
              className={styles.left}
              alt={""}
              src={
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC"
              }
            />
          </div>
          <div
            className={classnames(styles.rightButton, styles.explore_button)}
            onClick={this.onNextClick}
          >
            <img
              className={styles.right}
              alt={""}
              src={
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg=="
              }
            />
          </div>
        </div>
        <DayPicker
          className={classnames(
            "calendar",
            "collaboratorDayPicker",
            "MonthCollab",
            this.props.from === "MANAGER_VIEW" || "PORTAIL" ? "Padding10" : ""
          )}
          localeUtils={MomentLocaleUtils}
          locale={locale}
          month={new Date(this.state.year, this.state.month)}
          modifiers={{ ...defaultModifiers, ...modifiers }}
          fixedWeeks
        />
        <div className={styles.entete}>
          <div style={{ width: "90%" }}>
            <span
              className={classnames(
                styles.footer,
                !isAgenda && isBirthday ? styles.inactive : styles.footer
              )}
              onClick={() => this.OnAgendaClick()}
            >
              {_("monAgenda")}
              <hr
                className={classnames(
                  styles.line,
                  !isAgenda && isBirthday ? styles.inactive : styles.line
                )}
              />
            </span>
            <span
              style={{ display: "none" }}
              className={classnames(
                styles.footer,
                styles.birthday,
                isBirthday === false && isAgenda === true
                  ? styles.inactive
                  : styles.footer
              )}
              onClick={() => this.OnBirthdayClick()}
            >
              {_("myBirthdays")}
              <hr
                className={classnames(
                  styles.line,
                  styles.lineBirthDay,
                  !isBirthday && isAgenda ? styles.inactive : styles.line
                )}
              />
            </span>
          </div>
        </div>
        <div className={styles.tags_container}>{this.renderMonthsTags()}</div>
      </div>
    );
  };

  render() {
    return (
      <div className={styles.lower_section}>{this.renderCalendarSection()}</div>
    );
  }
}

export default CollaboratorCalendar;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceCalendar.js